export default "__VITE_ASSET__BZBpU4QV__"